import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { SharedHelpModel } from './shared-help.model';
import { Observable, of, Subscription } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { LocaleService } from '../locale/locale.service';
import { ContentServiceV2 } from '../services/api/content-v2.service';

@Component({
  templateUrl: './sharedHelpTextModal.component.html'
})

export class SharedHelpTextModalComponent implements OnInit {
  content$: Observable<string>;

  constructor(
    public dialogRef: MatDialogRef<SharedHelpTextModalComponent>,
    private contentService: ContentServiceV2,
    @Inject(MAT_DIALOG_DATA) public data: SharedHelpModel) {
  }

  ngOnInit() {
    this.content$ = this.contentService.getContent(this.data.name || this.data.title, this.data.locale).pipe(
      map(content => content.value),
      catchError(_ => of('No Help Content Available')),
    );
  }

  closeModal() {
    this.dialogRef.close();
  }
}
